(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/overview-earnings.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/overview-earnings.js');

'use strict';

const {
  getCurrencyType
} = svs.racing.common.strings;
const formatAmount = svs.utils.format;
const Earnings = _ref => {
  let {
    yearlyEarnings,
    career
  } = _ref;
  const earnings = [{
    label: 'Totalt insprunget',
    amount: career.earnings.earnings,
    currency: career.currency
  }, {
    label: 'Insprunget i år',
    amount: yearlyEarnings.currentYear.earnings,
    currency: yearlyEarnings.currency
  }];
  return React.createElement(React.Fragment, null, earnings.map(item => React.createElement("div", {
    className: "overview-earnings-item overview-whitebox",
    key: item.label
  }, React.createElement("span", {
    className: "block label fc-racing-900"
  }, item.label), React.createElement("span", {
    className: "f-700 f-bold"
  }, formatAmount.Currency(formatAmount.CurrencyAsJupiterString(item.amount)), ' ', getCurrencyType(item.currency)))));
};
svs.racing_game.components.statistics.Earnings = Earnings;

 })(window);